export enum CasesView {
  AllRecentCases = "All Recent Cases",
  NextArriving = "Next Arriving",
  Arrived = "Arrived",
  Archived = "Archived",
}
